module.exports = __webpack_public_path__ + "static/media/info.9314e704.svg";